import { Injectable } from "@angular/core";
import { User } from "src/app/_models/user-models/user";

@Injectable({
  providedIn: "root",
})
export class LocalStorageService {
  constructor() {}

  static setStorageValue(type: string, val: any) {
    localStorage.setItem(type, val);
  }

  static removeStorageValue(type: string) {
    localStorage.removeItem(type);
  }

  static setStorageValueWithStringify(type: string, val: any) {
    localStorage.setItem(type, JSON.stringify(val));
  }

  static clearStorageValue() {
    localStorage.clear();
  }

  static getStorageValue(type: string) {
    return localStorage.getItem(type);
  }

  static getSessionStorageValue(type: string) {
    return sessionStorage.getItem(type);
  }

  static setSessionStorageValue(type: string, val: any) {
    return sessionStorage.setItem(type, JSON.stringify(val));
  }

  static getStorageValueWithParse(type: string): any {
    return JSON.parse(localStorage.getItem(type));
  }

  static getUserStorageValue(): User {
    return JSON.parse(localStorage.getItem("user"));
  }

  static removeAllStorageValue() {
    localStorage.removeItem("MENU");
    localStorage.removeItem("current");
    localStorage.removeItem("currentUrl");
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("loginTime");
    sessionStorage.removeItem("token");
    localStorage.clear();
  }
}
